import React from "react";
import { useTranslation } from "react-i18next";
import Link from "../Link";

const SignUpButton = ({ children, ...rest }) => {
  const { t } = useTranslation();

  return (
    <Link
      {...rest}
      to={`${t("common.exchangeLink")}/accounts/sign-up`}
      rel="noopener noreferrer"
    >
      {children}
    </Link>
  );
};

export default SignUpButton;
